export default "__VITE_ASSET__CYiNHGA9__"